/* eslint-disable @typescript-eslint/no-explicit-any */
import { SelectOption } from '@talon/web/src/types';
import { Box, Select, SelectProps, Text } from 'grommet';
import { WidthType } from 'grommet/utils';
import { capitalize as capitalizeUtil } from 'lodash';
import { useState } from 'react';
import { TalonTip } from '.';

export interface ISelectableTextProps {
  val: any;
  options: SelectProps['options'];
  onChange: (value: string) => void;
  onBlur?: () => void;
  onSubmit?: () => void;
  id?: string;
  name?: string;
  required?: boolean;
  width?: WidthType;
  textSize?: 'small' | 'medium' | 'large' | 'xlarge' | string;
  textMargin?: 'small' | 'medium' | 'large' | 'xlarge' | string;
  textColor?: string;
  shortenTo?: number;
  placeholder?: string;
  emptySearchMessage?: string;
  capitalize?: boolean;
}

export const SelectableText = ({
  val,
  options,
  onChange,
  onBlur,
  onSubmit,
  id,
  name,
  required,
  width,
  textSize,
  textMargin,
  textColor,
  shortenTo,
  placeholder,
  emptySearchMessage,
  capitalize = false,
}: ISelectableTextProps) => {
  const [edit, setEdit] = useState<boolean>(false);

  const shortened = shortenTo && val.length > shortenTo ? `${val.slice(0, shortenTo - 1)}...` : val;

  const doChange = (selectedOption: SelectOption<any>) => {
    setEdit(false);
    onChange && onChange(selectedOption.value);
  };

  const doSubmit = () => {
    setEdit(false);
    onSubmit && onSubmit();
  };

  const doClose = () => {
    setEdit(false);
  };

  const doBlur = () => {
    onBlur && onBlur();
  };

  const takeFocus = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!edit) setEdit(true);
  };

  return edit ? (
    <Box width={width} margin={textMargin} alignSelf="start" gap="xxsmall" direction="row" align="center">
      <Box border={{ side: 'bottom', color: textColor || 'accent-3' }}>
        <Select
          id={id}
          name={name || id}
          value={val}
          onChange={({ value }) => doChange(value)}
          open
          color={textColor}
          onClose={doClose}
          onBlur={doBlur}
          onSubmit={doSubmit}
          labelKey="label"
          valueKey="value"
          options={options}
          required={required}
          size={textSize}
          emptySearchMessage={emptySearchMessage}
          plain
        />
      </Box>
    </Box>
  ) : (
    <Box
      width={width}
      margin={textMargin}
      border={{ side: 'bottom', color: textColor || 'accent-3' }}
      alignSelf="start"
      onClick={takeFocus}
    >
      {shortenTo ? (
        <TalonTip content={<Text>{val}</Text>}>
          <Text style={{ cursor: 'text' }} color={textColor}>
            {capitalize ? capitalizeUtil(shortened) : shortened}
          </Text>
        </TalonTip>
      ) : (
        <Box direction="row" height={{ min: '1.5rem' }}>
          {val ? (
            <Text style={{ cursor: 'text' }} color={textColor}>
              {capitalize ? capitalizeUtil(val) : val}
            </Text>
          ) : (
            <Text style={{ cursor: 'text' }} color={textColor}>
              <i>{placeholder || 'Choose...'}</i>
            </Text>
          )}
        </Box>
      )}
    </Box>
  );
};
